import { render, staticRenderFns } from "./IncomeTypeList.vue?vue&type=template&id=3d3daf62"
import script from "./IncomeTypeList.vue?vue&type=script&lang=js"
export * from "./IncomeTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports